<script setup>
const emit = defineEmits(["change"]);
import { ref } from "vue";
import { argonTableStore } from "@/_store/argonTableStore";
import DateCustomFilter from "./DateCustomFilter.vue";
const showModalDate = ref(false);
const props = defineProps({
  filter: {
    type: Object,
    required: true,
  },
  divider: {
    type: Boolean,
    default: false,
  },
});
function customDate(value, isActive) {
  showModalDate.value = !showModalDate.value;
  if (isActive) {
    value.storage.setCustomFilterDate(null);
    change(value, isActive);
  }
}
function closeDateFilter() {
  showModalDate.value = false;
}
function filterDateAccepted(res) {
  res.value.storage.setCustomFilterDate(res.newValue);
  res.value.value = res.newValue;
  change(res.value, false, res.label);
  closeDateFilter();
}
function change(value, isActive, customLabel = "") {
  const label = value.isCustomDate ? customLabel : value.label;

  let contract = {
    description: props.filter.label,
    field: props.filter.field,
    multi: props.filter.multi,
    label: label,
    value: value.value,
    active: !isActive,
    isDate: props.filter.isDate,
  };

  emit("change", contract);
}
const tableStore = argonTableStore();

function isActive(option) {
  const filter = tableStore.filters.find(
    (filter) => filter.field == props.filter.field
  );

  if (filter) {
    if (props.filter.multi) {
      if (filter?.value?.$in?.find((value) => option.value == value))
        return true;
    } else if (option.isCustomDate) {
      return !!filter?.value?.$gte;
    } else if (filter.text == option.label) return true;
  }
  return false;
}
</script>

<template>
  <div class="filter-group-label px-3 pt-2 pb-1">{{ filter.label }}</div>
  <ul class="list-unstyled mb-0">
    <li v-for="(option, key) of filter.options" :key="key">
      <template v-if="option.isCustomDate">
        <a
          class="dropdown-item border-radius-md filter-option"
          :class="{ 'filter-option-active': isActive(option) }"
          @click="customDate(option, isActive(option))"
        >
          <i v-if="isActive(option)" class="fa fa-check me-sm-2 check-icon"></i>
          <span v-else class="ms-4"></span>
          {{ option.label }}
        </a>
        <date-custom-filter
          v-if="showModalDate"
          class="custom-date-panel"
          :value="option"
          @click.stop
          @success="filterDateAccepted"
        />
      </template>

      <a
        v-else
        class="dropdown-item border-radius-md filter-option"
        :class="{ 'filter-option-active': isActive(option) }"
        @click="change(option, isActive(option))"
      >
        <i v-if="isActive(option)" class="fa fa-check me-sm-2 check-icon"></i>
        <span v-else class="ms-4"></span>
        {{ option.label }}
      </a>
    </li>
    <li v-if="divider">
      <hr class="filter-divider" />
    </li>
  </ul>
</template>

<style lang="scss" scoped>
.filter-divider {
  height: 0;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  background-color: transparent;
  opacity: 1;
  margin-bottom: 0;
  margin-top: 8px;
}

.filter-group-label {
  font-size: 0.7rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #8392ab;
}

.filter-option {
  color: var(--color-text-primary);
  font-size: 0.8125rem;
  transition: background-color 0.1s ease;

  &:hover {
    background-color: #f8f9fa;
  }
}

.custom-date-panel {
  position: relative;
  z-index: 1040;
  display: block;
  width: auto;
  min-width: 170px;
  padding: 20px;
  pointer-events: auto;
}

.custom-date-panel :deep(.form-control) {
  display: block !important;
  min-height: 2rem;
  opacity: 1;
  visibility: visible;
}
</style>
